import '../../resources/css/common/ModalConfirm.scss';
import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { doCloseModalConfirm } from '../../actions/index';

class ModalConfirm extends Component {

    submitConfrim = (isConfirm) => {
        const { confirmCallback, doubleConfirm, cancelCallback, doCloseModalConfirm } = this.props;
        if (isConfirm) {
            if (confirmCallback) {
                confirmCallback();
            } else {
                alert("confirmCallback is not the function.");
            }

            if (!doubleConfirm) {
                doCloseModalConfirm();
            }

        } else {
            if (cancelCallback) {
                cancelCallback();
            }
            doCloseModalConfirm();
            
        }
    }

    // componentDidMount() {
    //     // if call render will do this method
    //     this.updateShow();
    //   }

    // componentDidUpdate (prevProps, prevState, snapshot) {
    //     // if props change will call this method
    //     if (prevProps.show !== this.props.show) {
    //         this.updateShow();
    //     }
    // }

    render() {
        const { isConfirmShow, doCloseModalConfirm, modalIcon, confirmText, modalTitle, confirmHeight } = this.props;
        
        let renderContent;
        if (isConfirmShow) {
            renderContent = (
                <Modal
                
                    show={isConfirmShow}
                    dialogClassName='modal-confirm-detail'
                    centered
                    onHide={() => doCloseModalConfirm()}
                >
                    <Modal.Body style={{height: `${confirmHeight?confirmHeight:300}px`}}>
                        <div className='area-modal-detail-header'>
                            <Row>
                                <Col sm={10} className='area-modal-title'>
                                    <label>{confirmText.includes("delete") ? 'Delete' : (modalTitle ? modalTitle : 'Confirm')}</label>
                                </Col>
                                <Col sm={2} className='area-close-btn'>
                                    <span className='area-icon-close-detail' onClick={() => doCloseModalConfirm()}><span id="modal-confirm-close-btn" className="icon-btn-close-n"></span></span>
                                </Col>
                            </Row>
                        </div>
                        <div className='area-modal-detail-content'>
                            <div className='area-text-content'>
                                {/* <span className='icon-alert'></span> */}
                                {/* <br /> */}
                                {confirmText.includes("delete") ? <span className='icon-ico-failed'></span> : (modalIcon ? <span className={modalIcon}></span> : '')}
                                <br />
                                <label>{confirmText.split('?')[0] + "?"}</label>
                                <label>{confirmText.split('?')[1]}</label>
                            </div>
                            <hr />
                            <div className='area-btns'>
                                <Row className='area-btn-save'>
                                    <Col>
                                        <Button id="modal-confirm-cancel-btn" type="button" variant="primary" size="lg" onClick={() => this.submitConfrim(false)} block bsPrefix="btn btn-close">
                                            {confirmText.includes("leave") ? "Just Leave" : "Cancel" }
                                        </Button>
                                    </Col>
                                    <Col>
                                        {confirmText.includes("delete") ? <Button id="modal-confirm-delete-btn" type="submit" variant="primary" size="lg" onClick={() => this.submitConfrim(true)} block bsPrefix="btn btn-delete">
                                            Delete
                                        </Button> :
                                            <Button id="modal-confirm-confirm-btn" type="submit" variant="primary" size="lg" onClick={() => this.submitConfrim(true)} block bsPrefix="btn btn-save">
                                                Confirm
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )
        } else {
            renderContent = (<div className='modal-detail-empty'></div>);
        }

        return (
            <div className='area-modal-confirm-detail'>
                {renderContent}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        isConfirmShow: state.commonReducers.isConfirmShow,
        modalTitle: state.commonReducers.confirmTitle,
        modalIcon: state.commonReducers.confirmIcon,
        confirmText: state.commonReducers.confirmText,
        confirmHeight: state.commonReducers.confirmHeight,
        confirmCallback: state.commonReducers.confirmCallback,
        cancelCallback: state.commonReducers.cancelCallback,
        doubleConfirm: state.commonReducers.doubleConfirm
    }
}

export default connect(
    mapStateToProps,
    { doCloseModalConfirm }
)(ModalConfirm)